export default __webpack_public_path__ + "static/website-ro-947a82acbc0c5beed81bbee2c4dc5809.png";